import React from "react";
import "./ChecklistImportSuccess.scss";

export default function ChecklistImportSuccess({
  checklist,
  sourceName,
  onSource,
  onView,
  onBack,
  onImport,
}) {
  return (
    <section
      className="checklist-import-success"
      aria-label="Created checklist"
    >
      <div className="checklist-import-success__check" aria-hidden="true">
        <i className="bx bx-check" />
      </div>
      <h2>Checklist created successfully</h2>
      <p className="checklist-import-success__subtitle">
        Your checklist is ready to use.
      </p>
      <div className="checklist-import-success__summary">
        <header>
          <i className="bx bx-file" aria-hidden="true" />
          <h3>{checklist.name}</h3>
          <span>Created</span>
        </header>
        <dl>
          <div>
            <dt>Checklist ID</dt>
            <dd>{checklist.id}</dd>
          </div>
          <div>
            <dt>Sections</dt>
            <dd>{checklist.sections}</dd>
          </div>
          <div>
            <dt>Questions</dt>
            <dd>{checklist.questions}</dd>
          </div>
        </dl>
        <div className="checklist-import-success__source">
          <i className="bx bxs-file-pdf" aria-hidden="true" />
          <span>{sourceName || "Pasted text"}</span>
          <button type="button" className="btn btn-link" onClick={onSource}>
            View source <i className="bx bx-link-external" />
          </button>
        </div>
      </div>
      <p className="checklist-import-success__saved" role="status">
        <i className="bx bxs-check-circle" aria-hidden="true" /> All{" "}
        {checklist.questions} imported questions have been saved.
      </p>
      <div className="checklist-import-success__actions">
        <button type="button" className="btn btn-primary" onClick={onView}>
          View checklist
        </button>
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={onBack}
        >
          Back to checklists
        </button>
      </div>
      <button type="button" className="btn btn-link" onClick={onImport}>
        Import another checklist
      </button>
    </section>
  );
}
